<div class="change-password-container">
  <div class="change-password">
    <div class="change-password-header">
      <h6 class="form-title">Change Password</h6>
    </div>

    <form class="changePasswordForm" [formGroup]="changePasswordForm" (submit)="upadatePassword()" autocomplete="off">
      <div class="form-elements">
        <div class="">
          <label for="mobile" class="required">Mobile Number</label>
          <input class="form-control form-control-sm" type="text" formControlName="mobile" placeholder="Mobile Number"
            autocomplete="off" value="" maxlength="10" minlength="10" required readonly />
            <div class="error-section">
              @if (
                changePasswordForm.controls.mobile.errors &&
                (changePasswordForm.controls.mobile.touched ||
                changePasswordForm.controls.mobile.dirty)
                ) {
              <p class="err-msg" [hidden]="
                  !changePasswordForm.get('mobile').hasError('required')
                ">
                  Mobile Number is required
                </p>
                <p class="err-msg" [hidden]="!changePasswordForm.get('mobile').hasError('pattern')">
                  Invalid Mobile Number
                </p>
              }
            </div>
          </div>
        </div>
        <div class="form-actions text-center">
          <button type="submit" class="submit-pwd" [disabled]="changePasswordForm.invalid">
            <span>Send OTP</span>
          </button>
        </div>
      </form>
    </div>
  </div>